export default __webpack_public_path__ + "static/media/benefit_5@3x.0d6f6709.png";